export class NodeUserData {
    constructor(pOtherUserData = null) {
        if (pOtherUserData != null)
            this.mData = new Map(pOtherUserData.mData);
        else
            this.mData = new Map();
    }
    getData(pKey) {
        if (!this.mData.has(pKey))
            return (null);
        return this.mData.get(pKey);
    }
    setData(pKey, pValue) {
        this.mData.set(pKey, pValue);
    }
    assignToNode(pNode) {
        if (pNode == null)
            return;
        pNode[NodeUserData.USERDATA_PROPERTY] = this;
    }
    clone() {
        return (new NodeUserData(this));
    }
    static FromNode(pNode, pCreate = false) {
        if (pNode == null)
            return (null);
        let tData = pNode[NodeUserData.USERDATA_PROPERTY];
        if (tData != null) {
            return (tData);
        }
        if (pCreate) {
            tData = new NodeUserData();
            tData.assignToNode(pNode);
            return (tData);
        }
        else {
            return (null);
        }
    }
    static GetData(pNode, pKey) {
        const tUserData = NodeUserData.FromNode(pNode, false);
        if (tUserData != null)
            return (tUserData.getData(pKey));
        return (null);
    }
    static SetData(pNode, pKey, pValue) {
        const tUserData = NodeUserData.FromNode(pNode, true);
        if (tUserData != null)
            tUserData.setData(pKey, pValue);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
NodeUserData.USERDATA_PROPERTY = "egr_wcf_nodeUserData";
